<template>
  <v-menu
    offset-y
    attach="#app"
    transition="slide-y-transition"
    :close-on-content-click="false"
    :content-class="$style['basket-flyout-wrapper']"
    :value="basketIsVisible"
    :disabled="disabled || !hasMyRole"
    @input="toggleBasket"
  >
    <template #activator="{ on }">
      <span v-on="on">
        <slot />
      </span>
    </template>

    <div :class="$style['basket-flyout']">
      <MiniBasketContent :class="$style.basketContent" @close="toggleBasket" />
    </div>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { types as STOREMODULES } from '@/js/plugins/store/store-modules.js'

import APP_CONSTANTS from '@/js/plugins/store/modules/app/constants.js'
import APP_GETTERS from '@/js/plugins/store/modules/app/getter-types.js'
import APP_ACTIONS from '@/js/plugins/store/modules/app/action-types.js'

import MiniBasketContent from '@/js/components/Basket/Mini/MiniBasketContent.vue'

import PermissionMixin from '@/js/mixins/permission-mixin.js'
import { DP_ROLE } from '@/js/helper/dp-usermanagement-constants'

// import { toggleHTMLOverflowHidden } from '@/js/helper/dom-helper.js'

export default {
  name: 'MiniBasketFlyout',
  components: {
    MiniBasketContent,
  },
  mixins: [PermissionMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      myRole: DP_ROLE.SHOP_ORDER_R.p,
    }
  },
  computed: {
    ...mapGetters(STOREMODULES.APP, {
      basketIsVisible: APP_GETTERS.BASKET_VISIBILITY,
      isSmWidth: APP_GETTERS.IS_SM_WIDTH,
    }),
  },
  beforeDestroy() {
    this.hideOverlay()
    this.hideBasket()
  },
  methods: {
    ...mapActions(STOREMODULES.APP, {
      showOverlay: APP_ACTIONS.SHOW_OVERLAY,
      hideOverlay: APP_ACTIONS.HIDE_OVERLAY,
      showBasket: APP_ACTIONS.SHOW_BASKET,
      hideBasket: APP_ACTIONS.HIDE_BASKET,
    }),
    toggleBasket() {
      if (this[APP_CONSTANTS.BASKET_IS_VISIBLE]) {
        this.hideOverlay()
        this.hideBasket()
      } else {
        this.showOverlay()
        this.showBasket()

        // if (this.isSmWidth) {
        //   toggleHTMLOverflowHidden()
        // }
      }
    },
  },
}
</script>

<style lang="scss" module>
.basket-flyout-wrapper {
  // }
  // @media screen and (max-width: map-get($grid-breakpoints, 'md')) {
  //   top: 0 !important;
  //   // bottom: 0;
  //   z-index: 9999 !important;

  //   height: 100%;
  // }
  position: fixed;
  // @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  top: 5rem !important;
  right: 0 !important;
  left: auto !important;

  width: 50%;
  min-width: 46rem !important;
  max-width: 100%;
  height: auto;

  border-radius: 0;
  box-shadow: none;
}

.basket-flyout {
  // @media screen and (max-width: map-get($grid-breakpoints, 'md')) {
  //   height: 100%;
  // }
  z-index: 999;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  min-height: 13rem;

  background: var(--white);
  border-top: 10px solid var(--black);

  .basketContent {
    // @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
    //   height: auto;
    // }
    position: relative;

    height: 100%;
  }
}
</style>
